import { Component, Input } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";

// clickable-cell.component.ts
@Component({
    selector: 'app-clickable-cell',
    templateUrl: './clickable-cell.component.html',
    styleUrls: ['./clickable-cell.component.css']})
export class ClickableCellComponent {
  @Input() value: any;
  @Input() row: any;
  @Input() onClick!: (event: MouseEvent, value: any, row: any) => void;

  get content(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.value);
  }

  constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
    private router: Router) { }

  handleClick(event: MouseEvent): void {

    this.router.navigate(['/inventory/inventory-update/' + this.value], {

    });

  }
}